var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.32V27.32M29.3333 6.22667V22.32C29.3333 23.6 28.2933 24.8 27.0133 24.96L26.5733 25.0133C23.6667 25.4 19.1867 26.88 16.6267 28.2933C16.28 28.4933 15.7067 28.4933 15.3467 28.2933L15.2933 28.2667C12.7333 26.8667 8.26666 25.4 5.37333 25.0133L4.98666 24.96C3.70666 24.8 2.66666 23.6 2.66666 22.32V6.21334C2.66666 4.62667 3.96 3.42667 5.54666 3.56C8.34666 3.78667 12.5867 5.2 14.96 6.68L15.2933 6.88C15.68 7.12 16.32 7.12 16.7067 6.88L16.9333 6.73334C17.7733 6.21334 18.84 5.69334 20 5.22667V10.6667L22.6667 8.89334L25.3333 10.6667V3.70667C25.6933 3.64 26.04 3.6 26.36 3.57334H26.44C28.0267 3.44 29.3333 4.62667 29.3333 6.22667Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 3.70667V10.6667L22.6667 8.89333L20 10.6667V5.22667C21.7467 4.53333 23.6933 3.97333 25.3333 3.70667V3.70667Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.6a6bd0ff7d124f7ef0b01038c5eb089c.svg";
export { ForwardRef as ReactComponent };